import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const notesCreateSlice = createApi({
    reducerPath: "notesCreate",
    baseQuery: fetchBaseQuery({
        baseUrl: "https://brand-logistics.demo.permute.in",
        prepareHeaders: (headers, { getState }) => {
            const token = localStorage.getItem("authToken");
            if (token) {
                headers.set("authorization", "Bearer " + token);
            }
            return headers;
        },
    }),
    endpoints: (builder) => ({
        notesCreate: builder.mutation({
            query: (data) => ({ url: "/order-management/api/v1/ordernotes/create", method: "POST", body: data }),
        }),
    }),
});

export const { useNotesCreateMutation } = notesCreateSlice;
